<template>
    <div id="planning_provinsi" >

<section class="content">
<div class="container-fluid">

    <div class="row clearfix">

        <div class="bg-light-green" style="margin-top:-1% !important;">
            <!-- <br> -->
            <div class="row paddingku">
                <div class="col-md-3 searching">
                    <span class="h_page">Master Golongan</span> <br> <br>
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-3 searching">
                    <div class="input-group">
                        <span class="input-group-btn">
                            <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                        </span>
                        <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" >
                    </div> <br>
                </div>
            </div>
        </div>


        <div class="col-xs-12 card">
    <!-- ============================================================ MULAI ======================================================================== -->
            <br>
            <div class="table-responsive">
                <table class="table table-bordered" style="width: 100%">
                    <thead>
                    <tr class="bg-info">
                        <th style="width: 5%">No.</th>
                        <th style="width: 40%">Pangkat</th>
                        <th style="width: 10%">Golongan</th>
                        <th style="width: 10%">Ruang</th>
                        <th style="width: 20%">Keterangan</th>
                        <th style="width: 15%"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-if="cek_load_data">
                            <td colspan="6" class="text-center">
                                <img src="images/loading.gif" width="10%">
                            </td>
                        </tr>
                        <template v-if="!cek_load_data">
                            <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.provinsi_id">
                                <td>{{index+1}}</td>
                                <td>{{data.pangkat}}</td>
                                <td>{{data.gol}}</td>
                                <td>{{data.ruang}}</td>
                                <td>{{data.keterangan}}</td>

                                <td class="text-center" >

                                    <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                        <i class="material-icons" >create</i>
                                    </button>
                                        &nbsp;
                                    <button @click="removeData(data.jns_golongan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                        <i class="material-icons" >clear</i>
                                    </button>
                                </td>
                            </tr>
                        </template>

                    </tbody>
                </table>
            </div>

            <hr>
                <div class="text-center">
                    <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                        <i class="material-icons">skip_previous</i>
                    </button>
                    &nbsp;
                    <span style="font-size: 85%; color: #a5a5a5">
                        <b>{{page_first}} - {{page_last}}</b>
                    </span>
                    &nbsp;
                    <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                        <i class="material-icons">skip_next</i>
                    </button>
                </div>
            <hr>

            <!-- ============================================================ MODAL ======================================================================== -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>
                            <form @submit.prevent="addData()">

                                <div class="modal-body">
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Pangkat</label>
                                        </div>
                                        <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input type="text" v-model="data.pangkat" id="kode_provinsi" class="form-control" placeholder="Kode Provinsi" required>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Golongan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.gol" type="text" id="nama_provinsi" class="form-control" placeholder="Ex : Sulawesi Tenggara" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Ruang</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.ruang" type="text" id="nama_provinsi" class="form-control" placeholder="Ex : Sulawesi Tenggara" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Keterangan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.keterangan" type="text" id="nama_provinsi" class="form-control" placeholder="Ex : Sulawesi Tenggara" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>

                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">

                                <div class="modal-body">
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Pangkat</label>
                                        </div>
                                        <div class="col-md-10">
                                        <div class="form-group">
                                            <div class="form-line">
                                                <input type="text" v-model="data.pangkat" id="kode_provinsi" class="form-control" placeholder="Kode Provinsi" required>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Golongan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.gol" type="text" id="nama_provinsi" class="form-control" placeholder="Ex : Sulawesi Tenggara" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Ruang</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.ruang" type="text" id="nama_provinsi" class="form-control" placeholder="Ex : Sulawesi Tenggara" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Keterangan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.keterangan" type="text" id="nama_provinsi" class="form-control" placeholder="Ex : Sulawesi Tenggara" required>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


            <!-- ============================================================ MODAL ======================================================================== -->




    <!-- ============================================================ MULAI ======================================================================== -->
        </div>

    </div>

    </div>
    </section>



</div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/simpeg_golongan/';
    export default {
        name: "planning_provinsi",
        data() {
            return {
                data:{
                    jns_golongan_id: '',
                    pangkat: '',
                    gol: '',
                    ruang: '',
                    keterangan: '',
                },

                provinsi_id: '',
                list_data: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                cek_load_data : true,
            };
        },

        mounted() {
            this.getData();
            localStorage.sidemenu = 'simpeg';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                  console.log(data_urusan);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((datanya) => {
                    // console.log(datanya);
                  this.list_data = datanya.data;
                  this.page_last = datanya.jml_data;


                  this.cek_load_data = false;
                  
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                this.data = {
                    jns_golongan_id: data.jns_golongan_id,
                    pangkat: data.pangkat,
                    gol: data.gol,
                    ruang: data.ruang,
                    keterangan: data.keterangan,
                };
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                    id: '',
                    kode_urusan: '',
                    nama_urusan: '',
                    user: '',
                    createdtime: ''
                };
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
                this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                this.cek_load_data = true;
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.cek_load_data = true;
                this.page_first = 1;
                this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
